/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BankTransferIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BankTransferIcon({
  children,
  viewPath = "/DesignSystem/Svgs/BankTransferIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="BankTransferIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-2s21q5': alignSelf,'--mt-2-2s21q5': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2s21q5': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2s21q5': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2s21q5': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2s21q5': opacity,'--w-10-2s21q5': typeof width === 'number' ? `${width}px` : width,'--h-11-2s21q5': typeof height === 'number' ? `${height}px` : height,'--a-7-2s21q5': isAnimated ? animation : "none",'--sd-8-2s21q5': isAnimated ? strokeDashoffset : 0,'--sd-9-2s21q5': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="BankTransferIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M9.9 6l-6.7 6.7 6.7 6.6M18.3 12.7H3.2M22.1 12.7l6.7 6.6-6.7 6.7M13.7 19.3h15.1"
 style={{'--f-12-2s21q5': fill,'--s-13-2s21q5': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}